/**
 * MUI Autocomplete default getOptionLabel does `option.label`.
 * If options contain null/undefined (common from DB category columns),
 * Safari/WebKit throws: null is not an object (evaluating 'e.label').
 */

export function sanitizeStringOptions(options: unknown[] | null | undefined): string[] {
  if (!Array.isArray(options)) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const opt of options) {
    if (typeof opt !== 'string') continue;
    const trimmed = opt.trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    out.push(trimmed);
  }
  return out;
}

export function stringOptionLabel(option: unknown): string {
  if (option == null) return '';
  if (typeof option === 'string') return option;
  if (typeof option === 'object' && 'label' in (option as object)) {
    const label = (option as { label?: unknown }).label;
    return label == null ? '' : String(label);
  }
  return String(option);
}
